module.exports = __webpack_public_path__ + "img/img151_6.abcedfc0.png";